var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18925 8.67505L3.84429 11.3301L6.49933 8.67505L7.68866 9.856L3.84429 13.7004L0.00830078 9.856L1.18925 8.67505Z",
    fill: "#ACABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84437 2.66983L6.49941 5.32488L7.68036 4.14393L3.84437 0.299561L0 4.14393L1.18932 5.32488L3.84437 2.66983Z",
    fill: "#ACABAB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/upDown.09d4a4e74c3b942679d12353ac86d338.svg";
export { ForwardRef as ReactComponent };